import { FC } from "react";

import useShallowSelector from "./../../../hooks/useShalowSelector";
import { selectFormNotificationsSettings } from "./../../../store/settings/selectors";
import EmailNotificationSection from "./EmailNotification";
import RespondentNotification from "./RespondentNotification";

import styles from "./styles.module.scss";

const Notification: FC = () => {
    const notificationSettings = useShallowSelector(selectFormNotificationsSettings);

    return (
        <>
            {/* <div className={styles.section}>
                <label className={styles.switchContainer}>
                    <Switch checked={pushNotification} onChange={() => setPushNotification(!pushNotification)} />

                    <p className={styles.subTitle}>Push Notification</p>
                </label>

                {pushNotification && (
                    <>
                        <p className={styles.subTitle}>
                            Title
                            <Button icon={IconTypes.SINGLE_LINE} iconSize={18} />
                        </p>

                        <Input id="settings.notification.pushNotification.title" initialValue="You have a new entry!" />

                        <p className={styles.subTitle}>
                            Message
                            <Button icon={IconTypes.SINGLE_LINE} iconSize={18} />
                        </p>

                        <Input id="settings.notification.pushNotification.message" initialValue="{Form_title}" />

                        <Button variant={ButtonVariant.PRIMARY} text="Save" />
                    </>
                )}
            </div> */}

            {/* <div className={styles.line} /> */}

            <EmailNotificationSection notificationSettings={notificationSettings} />

            <div className={styles.line} />

            <RespondentNotification notificationSettings={notificationSettings} />
        </>
    );
};

export default Notification;
